import React from 'react';
import _ from 'lodash';

import InputSelectField from './InputSelectField';
import InputNumberField from './InputNumberField';

import Validation from '../../Entities/Validation';
import useValidationLineItemMetaOptions from '../../Hooks/useValidationLineItemMetaOptions';

import './InvoiceLineItemTableRow.scss';

const InvoiceLineItemTableRowValidationFields = function({ lineItem, inputId, newMode, onChange, fieldConfiguration }) {
  const { validationTypeOptions, productNameOptions } = useValidationLineItemMetaOptions({ lineItem, fieldConfiguration, newMode });

  const _onChange = function(inputId) {
    return value => {
      const _lineItem = _.cloneDeep(lineItem);
      if (!_lineItem.fields.validation.value) {
        _lineItem.fields.validation.value = new Validation();
      }
      _lineItem.fields.validation.value.fields[inputId].value = value;

      onChange(_lineItem);
    };
  }

  return (
    <>
      <div className="parkchirp--invoice-line-item-table--rate-type-column parkchirp--invoice-line-item-table--cell">
        <InputSelectField inputId={`${inputId}--rate-type`}
          options={validationTypeOptions}
          value={lineItem.fields.validation.value?.fields.type.value}
          onChange={_onChange('type')}
          editMode={newMode}
        />
      </div>
      <div className="parkchirp--invoice-line-item-table--product-name-column parkchirp--invoice-line-item-table--cell">
        <InputSelectField inputId={`${inputId}--product-name`}
          options={productNameOptions}
          value={lineItem.fields.validation.value?.fields.product_name.value}
          onChange={_onChange('product_name')}
          editMode={newMode}
        />
      </div>
      <div className="parkchirp--invoice-line-item-table--quantity-column parkchirp--invoice-line-item-table--cell">
        <InputNumberField inputId={`${inputId}--quantity`}
          value={lineItem.fields.validation.value?.fields.quantity.value}
          onChange={_onChange('quantity')}
          editMode={newMode}
        />
      </div>
    </>
  );
}

export default InvoiceLineItemTableRowValidationFields;
